import appWithAI from '@devices/settings/device_settings/app_settings_temperature_with_ai.js';
import device_information from '@devices/settings/device_settings/device_information';
import share from '@devices/settings/device_settings/share.js';

export default {
	name: 'ShellyBLUHTDi',
	friendly_name: 'BLU HT Display ZB',
	category: 'sensor',
	family: 'sensor',
	isPM: false,
	modes: {
		sensor: {
			channels: 1,
			notifications: ['device_problem', 'lowBattery'],
			charts: true,
			bluetooth_settings: [
				{ title: 'fahrenheit_unit', component: 'fahrenheit_unit_ble' },
				{ title: 'invert_display', component: 'invert_display_ble' },
				{ title: 'power_saver', component: 'power_saver_ble' },
				{ title: 'clock_sync', component: 'clock_sync_ble' },
				{ title: 'zigbee', component: 'zigbee_ble' },
				{ title: 'security', component: 'security_ble' },
			],
			settings: [
				appWithAI,
				share,
				{
					title: 'settings',
					components: [
						{ title: 'clock_format', component: 'clock_format_ble' },
						{
							title: 'temperature_offset',
							component: 'temperature_offset_ble',
						},
						{
							title: 'humidity_offset',
							component: 'humidity_offset_ble',
						},
						{
							title: 'bright_threshold',
							component: 'bright_threshold_ble',
						},
						{
							title: 'dark_threshold',
							component: 'dark_threshold_ble',
						},
						{ title: 'firmware_version', component: 'firmware_update_ble' },
						{ title: 'factory_reset', component: 'factory_reset_ble' },
					],
				},
				device_information,
			],
		},
	},
};
